<script>
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import SeekForwardIcon from '../icons/SeekForwardIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'
</script>

<ControlBarButton
  onclick={() => videoStore.state.videoController?.seekForward()}
  tooltip={translationsStore.state.seek_forward}
>
  <SeekForwardIcon />
</ControlBarButton>
